import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";

export const ProductModalContext = createContext(null);
export const useProductModal = () => {
  const context = useContext(ProductModalContext);
  const navigate = useNavigate();
  return context || { openProduct: path => navigate(path) };
};
